<div class="flex flex-column flex-center flex-flat bottom-spacer">
  <div class="text-muted">{{ 'general.api_cart_time_remaining' | translate }}</div>
  <div class="heading-5 no-margin">
    <ng-container *ngIf="isTimerDefined">
      <span>{{ hours | number: '2.0-0' }}:</span>
      <span>{{ minutes | number: '2.0-0' }}:</span>
      <span>{{ seconds | number: '2.0-0' }}</span>
    </ng-container>
    <app-loader class="top-spacer-half" [loading]="!isTimerDefined" [size]="16"></app-loader>
  </div>
</div>
